import { http } from '@/lib'
import { PaymentFormInputs } from '../state/detail/use-detail'

function fakeGetReimbursementById(): Promise<any> {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = {
        uuid: 'be353319-163c-4320-b212-1de63baf4af5',
        description: 'teste',
        amount: 2111.0,
        currencyCode: 'MXN',
        status: 'FINANCE_REJECTED',
        submittedDate: '2024-09-16',
        expenseDate: '2024-09-05',
        paymentDate: '2024-09-17',
        markAsPaidAt: '2024-09-17',
        countryCode: 'MX',
        userBank: {
          uuid: '4a0bc123-12a7-4538-a9f0-ab0d3ffe862d',
          accountNumber: '012180015379406966',
          taxPayerId: 'PAGL9705039D2',
          countryCode: 'MX',
          name: 'Luis Paczka',
          userUUID: 'a5c508fc-18a5-4fec-a8eb-f68c84be41f5',
          // userUUID: '17a9f9bf-9a5d-48dc-811e-293a8e5e72a7', // propia
          enabled: true,
          createdAt: 1726514023.753375,
          updatedAt: null,
        },
        category: {
          key: '2',
          description: 'Entretenimiento',
        },
        merchant: {
          code: '550e8400-e29b-41d4-a716-446655440055',
          logo: null,
          name: 'Cinépolis',
          description: 'Cadena de cines líder en entretenimiento',
          countryCode: 'MX',
          categoryKey: '2',
        },
        attachments: [
          {
            documentId: '0164b5af-df22-4a4c-b76e-a5fd5c0e80f4',
            documentName: 'blob',
            externalDocId: null,
            link: 'https://company-bc7c08f9-97c4-4d2e-a515-90aa5acebe04.s3.amazonaws.com/company_docs/bc7c08f9-97c4-4d2e-a515-90aa5acebe04/153/130060?response-content-disposition=attachment%3B%20filename%3D%22blob%22&response-content-type=&X-Amz-Security-Token=FwoGZXIvYXdzEPz%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDDvbu8FIg7SajV7GaSKwAU%2FGQixLMafyhvpiQ%2FK0Eo6glTYVOADDhPpXcaOK3DghYEm573%2FNL1C3TBVEE4h7MmF16nVWZJ4IEYb4P19IF5vVMQjBJyH9zm2KlMG14H7UC6MCq99R0qXjHJDB3kzSH8L7ND2ay0hMkwjFpjaWixavkI7deYB3EuRXCuH6QfgIJ0ioqPBNtHNt6u9nV4Z3jkHMeIqhN%2FC5kq4i6Qd7021R9hVUcMnZl%2FzszMhj1ndCKM7OhLkGMi2oDNHAuPyhCw%2BVl3OVzlYdGjPtCn8yXDCYYn4EzQCbinPwL5gnKab0yhVA0p8%3D&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20241029T182842Z&X-Amz-SignedHeaders=host&X-Amz-Expires=43200&X-Amz-Credential=ASIAWPJZAC5KPZRUU6WU%2F20241029%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Signature=cdf64116810e8a4cb779e7d07f53c87b413e42b52d5134a33fd5ba9adcf8f9d3',
          },
        ],
        approvers: [
          {
            role: '0',
            name: 'Luis Test Paczka l2',
            uuid: 'a5c508fc-18a5-4fec-a8eb-f68c84be41f5',
            level: 1,
            status: 'APPROVED',
            approveDate: '2024-09-16T19:38:53.072559568',
            rejectionReason: null,
            type: null,
          },
          {
            role: '1',
            name: 'Ana María López',
            uuid: 'b6d508fc-18a5-4fec-a8eb-f68c84be41f6',
            level: 2,
            status: 'APPROVED',
            approveDate: '2024-09-17T10:15:30.000000000',
            rejectionReason: null,
            type: null,
          },
          {
            role: '2',
            name: 'Carlos Pérez',
            uuid: 'c7e508fc-18a5-4fec-a8eb-f68c84be41f7',
            level: 3,
            status: 'APPROVED',
            approveDate: '2024-09-18T14:45:00.000000000',
            rejectionReason: null,
            type: null,
          },
          {
            role: '3',
            name: 'María Fernanda Gómez',
            uuid: 'd8f508fc-18a5-4fec-a8eb-f68c84be41f8',
            level: 4,
            status: 'REJECTED',
            approveDate: '2024-09-19T09:00:00.000000000',
            rejectionReason: 'Insufficient documentation',
            type: null,
          },
        ],
        paymentMethod:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vestibulum luctus orci eu lobortis. Maecenas id sapien aliquet, gravida urna ligula',
        paymentReference: 123456,
        paymentNote:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vestibulum luctus orci eu lobortis. Maecenas id sapien aliquet, gravida urna ligula',
        paymentConcept:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vestibulum luctus orci eu lobortis. Maecenas id sapien aliquet, gravida urna ligula',
        financeRejectionComment: 'Comment rejected finance',
        financeResolutionMarkedAt: '2024-09-17',
        financeResolutionMarkedBy: 'Jesús Durán',
      }

      resolve(data)
    }, 3000)
  })
}

function fakePut(): Promise<any> {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('ok')
      // reject("ok");
    }, 3000)
  })
}

export interface approveReimbursementByIdResponse {
  success: number
  rejected: number
  // TODO: type
  approvalsResponse: any
}
export interface RejectReimbursementParams {
  id: string
  comment: string
}

export const getReimbursementById = async (id: string) => {
  return http.get<any>(`/${id}`).then((res) => res.data)
  // return fakeGetReimbursementById()
}

export const approveReimbursementById = async (id: string) => {
  const data = {
    uuids: [id],
    status: 'APPROVED',
  }
  return http
    .put<approveReimbursementByIdResponse>('/status', data)
    .then((res) => res.data)
}

export const rejectReimbursementById = async (
  id: string,
  comment: string,
  status = 'REJECTED',
) => {
  const data = {
    uuids: [id],
    status,
    comment,
  }
  return http.put<any>('/status', data).then((res) => res.data)
}

export const cancelReimbursementById = async (id: string) => {
  return http.put<any>('/status', id).then((res) => res.data)
}

export const deleteReimbursementById = async (id: string) => {
  return http.delete<any>('/', { data: [id] }).then((res) => res.data)
}

export const markAsPaidReimbursementById = async (
  id: string,
  formValues: PaymentFormInputs,
) => {
  const data = {
    reimbursements: [
      {
        uuid: id,
        ...formValues,
      },
    ],
  }
  return http.post<any>('/mark-as-paid', data).then((res) => res.data)
}

export const attachmentReimbursementById = async (file: string) => {
  const formData = new FormData()
  formData.append('file', file)
  return http.post<any>('/attachment', formData).then((res) => res.data)
}
